import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';
import TapAnywhereMenuAction from '../enums/TapAnywhereMenuAction';
import TapAnywhereType from '../enums/TapAnywhereType';

type logTapAnywhereMenuTappedParams = {
  action_taken: TapAnywhereMenuAction;
  map_location?: MapLocation;
  point_type?: TapAnywhereType;
  source_id?: string;
};

/**
 * The user takes an action in the tap-anywhere menu that opens after long-pressing a point on the map. Dismissal is reported here as the 'close menu' action rather than as a separate event. Fires on both the Explore and Navigator maps; use map_location to distinguish.
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - The action the user took in the tap-anywhere menu.
 * @param params.map_location - The map surface the tap-anywhere menu opened on (e.g. Explore or Navigator).
 * @param params.point_type - The kind of map feature the selected point resolved to, from the highest-priority feature under the press.
 * @param params.source_id - The identifier of the map feature the selected point resolved to: the POI id, trail id, or waypoint id per point_type. Absent for a bare coordinate with no underlying feature.
 */
const logTapAnywhereMenuTapped = ({ action_taken, map_location, point_type, source_id }: logTapAnywhereMenuTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'tap anywhere menu tapped',
    { 'action taken': action_taken, 'map location': map_location, 'point type': point_type, 'source id': source_id },
    callback
  );
};

export default logTapAnywhereMenuTapped;
